import React from 'react';
import styled from "styled-components";
import {SectionTitle} from "../../../components/SectionTitle";
import {Benefit} from "./Benefit";
import {FlexWrapper} from "../../../components/FlexWrapper";
import {theme} from "../../../styles/Theme";

export const Benefits = () => {
    return (
        <StyledBenefits>
            <SectionTitle>Our Services Bring Valuable Benefits</SectionTitle>
            <BenefitsList>

            <FlexWrapperStyled wrap={'wrap'} justify={'space-between'} align={'center'} gap={"40px"}>
                <Benefit iconId={'eco'} title={'Eco-Friendly Cleaning'}
                         description={'Our professional house cleaning services in Adelaide use eco-friendly and non-toxic products - safe for your family, pets, and home surfaces.'}></Benefit>
                <Benefit iconId={'safe'} title={'Trusted & Safe'}
                         description={'Every cleaner is police-checked, fully insured, and trained, so you can feel confident letting us into your home.'}/>
                <Benefit iconId={'experienced'} title={'Experienced Professionals'}
                         description={'With over 3 years of hands-on cleaning experience in Adelaide, our trained staff deliver reliable, top-quality results every time.'}/>
            </FlexWrapperStyled>
            </BenefitsList>
        </StyledBenefits>
    );
};

const StyledBenefits = styled.section`
    //background-color: #9c82b8;
    //text-align: center;
    //height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Равномерно распределяем элементы */
    align-items: center;
    padding-bottom: 10px;



`


const BenefitsList=styled.div`
    padding: 60px 0;
    `
const FlexWrapperStyled = styled(FlexWrapper)`
    @media ${theme.media.tablet} {
        flex-direction: column;
        align-items: center;
        gap: 40px; // добавление промежутка между блоками на мобильной версии
    }`